import React, {Fragment, useState, useRef} from 'react';
import Popup from './Popup';
import TextField from '@material-ui/core/TextField';
import {Text, Select, Date_picker} from '../../../../../../../components';
import Grid from '@material-ui/core/Grid';
import {Form, Field} from 'react-final-form';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DealSelect from './DealSelect';
import {connect} from 'react-redux';


function Tasks(props){
  const[delete_mode, setDeleteMode]=useState(false);
  const[loading, setLoading]=useState();
  let fp=useRef();
  let formRef=useRef();

  function onSubmit(params){
      formRef.current.reportValidity();
      if(formRef.current.checkValidity()==true){
          if(params.task_queue_id=='new'){delete params.task_queue_id;}
          if(params.id!=undefined){if(props.initial_task.contact_id!=undefined){params.original_type='contact';}else{params.original_type='company';} params.company_id=props.company.id; props.updateTimelineItem(params.id, 'tasks', params);}
          else{props.createTimelineItem('tasks', {...params, company_id:props.company.id});}
          props.handleClose();
          if(params.next_prospect==true){props.nextProspect();}

      }
  }

  let user_workspace_id=null;
  let owners=[{id:null, name:'No owner'}];
  if(props.workspace_data!=undefined){let us=props.workspace_data.user_workspaces; for(let key in us){if(us[key].user_id==props.me.id){user_workspace_id=us[key].id;} owners.push({id:us[key].id, name:us[key].first_name+' '+us[key].last_name})}}

  let task_contacts=[];
  if(props.company!=undefined){
    for(let x of props.company.contacts){
      if(x.pivot.active_at_company==true){
      let contact={id:x.id};
      if(x.first_name!=null){contact.name=x.first_name+' ';}
      if(x.last_name!=null){contact.name+=x.last_name;}
      if(contact.name==undefined){contact.name='No name';}
      task_contacts.push(contact)
  }}}
  let queues=[{id:'new', name:'New'}];
  if(props.queues!=undefined){for(let key in props.queues){queues.push(props.queues[key]);}}
  let initial_deal_id=(props.initial_task!=undefined && props.initial_task.deal_id!=undefined)?props.initial_task.deal_id:(props.main_deals==undefined || props.main_deals[props.company.id]==undefined)?undefined:props.main_deals[props.company.id];
  return(
    <Popup initial_values={props.initial_task} openDraft={props.reOpen} draft_type="TASK" company_id={props.company.id} form_props={fp} button_text={(delete_mode==true)?'Delete':'Save'} title={(delete_mode==true)?'Delete task':(props.timeline_item!=undefined)?'Update task':'Create task'} submit_button icon={<AssignmentIcon color='primary'/>} handleClose={props.handleClose} handleDelete={(props.initial_task==undefined || props.initial_task.id==undefined || delete_mode==true)?undefined:()=>{setDeleteMode(true);}} accept_button_click={()=>{if(delete_mode==true){props.deleteTimelineItem(props.initial_task.id, 'tasks', props.company.id); props.handleClose();}else{fp.current.form.submit();}}} content={
          <Form
            onSubmit={onSubmit}
            initialValues={(props.initial_task==undefined)?{deal_id:initial_deal_id, owner_id:user_workspace_id, priority:3, sub_type:2}:
            {...props.initial_task,
               deal_id:initial_deal_id, 
               sub_type:(props.initial_task.sub_type==undefined)?props.initial_task.type:props.initial_task.sub_type, 
               quick_due_date:(props.initial_task.date_time==undefined || props.initial_task.quick_due_date!=undefined)?props.initial_task.quick_due_date:9, 
               user_workspace_id:(props.initial_task.user_workspace_id==undefined)?user_workspace_id:props.initial_task.user_workspace_id, 
               task_queue_id:(props.initial_task.task_queue_timeline_item==undefined || props.initial_task.task_queue_id!=undefined)?props.initial_task.task_queue_id:props.initial_task.task_queue_timeline_item[0].task_queue_id, 
               priority:(props.initial_task.task_queue_timeline_item==undefined || props.initial_task.priority!=undefined)?(props.initial_task.priority==undefined)?3:props.initial_task.priority:props.initial_task.task_queue_timeline_item[0].priority,
              }}
          >
            {form_props =>{ fp.current=form_props; return(
              <form ref={formRef} onSubmit={form_props.handleSubmit}>
                <Fragment>
                  {(delete_mode==true)?
                    <Typography style={{width:'calc(100% - 40px)', height:'100px', marginTop:'50px', textAlign:'center'}}>Are you sure you want to delete this task? This action can not be undone.</Typography>
                        :
                    <Grid container style={{width:'calc(100% - 40px)'}}>
                    <Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Select title='Queue' required name='task_queue_id' select_data={queues}/></Grid>
                    <Field name='task_queue_id'>{(f)=>(f.input.value=='new')?<Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Text required title='Queue name' name='task_queue_name'/></Grid>:null}</Field>
                    <Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Select title='Contact' required name='contact_id' select_data={task_contacts}/></Grid>
                    <Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Select title='Due date' required name='quick_due_date' select_data={[{id:0, name:'Today'}, {id:1, name:'Tomorrow'}, {id:2, name:'After tomorrow'}, {id:3, name:'In 3 days'}, {id:4, name:'In 4 days'}, {id:5, name:'In 5 days'}, {id:6, name:'Next week'}, {id:7, name:'In 2 weeks'}, {id:8, name:'Next month'}, {id:9, name:'Custom'}]}/></Grid>
                    <Field name='quick_due_date'>{(f)=>(f.input.value!=9)?null:<Grid item xs={12} sm={6} style={{marginBottom:'10px'}}><Field name='date_time'>{(f)=><Date_picker title='Due date' date_time value={f.input.value} onChange={f.input.onChange}/>}</Field></Grid>}</Field>
                    <Grid item xs={12} sm={6} style={{marginBottom:'15px'}}><Select title='type' required name='sub_type' select_data={[{id:1, name:'Research Note'}, {id:0, name:'Email'}, {id:4, name:'Send message'}, {id:2, name:'Phone call'}, {id:3, name:'Other'}]}/></Grid>
                    {(props.workspace_data!=undefined && props.workspace_data.admin==true)?<Grid item xs={12} sm={6} style={{marginBottom:'10px'}}><Select title='Owner' name='user_workspace_id' select_data={owners}/></Grid>:null}
                    <Grid item xs={12} sm={6} style={{marginBottom:'10px'}}><Select title='Priority' name='priority' select_data={[{id:0, name:'High'}, {id:1, name:'Medium'}, {id:3, name:'Low'}]}/></Grid>
                    <DealSelect {...props}/>
                    <Grid item xs={12}><Text title='Note' required name='timeline_item_content.content' multiline rows={4} variant='outlined' style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px'}}/></Grid>
                    </Grid>
                }
                </Fragment>
          </form>)}}</Form>
        }/>
  )
}

export default connect(ss, dd)(Tasks);

function ss(state){
  return{
    deals:state.deals.deals,
    main_deals:state.deals.main_deals,
    queues:state.lists.queue_data
  }
}


function dd(dispatch){
  return{
    createQueue:(payload)=>{dispatch({type:'REQUEST_QUEUE_CREATE', payload:payload})}
  }
}
